import axios from 'axios';


const apiMonitoraggioIp = axios.create({
  baseURL: `https://api.country.is`,
});

export default apiMonitoraggioIp;